import React from "react";

interface CpuCountLabelProps {
  count: number;
}

function CpuCountLabel({ count }: CpuCountLabelProps) {
  const cpuCount = Number.isNaN(count) || count < 1 ? 1 : count;

  return (
    <div
      className="min-w-[3rem] h-12 rounded-lg border-2 flex flex-col items-center justify-center p-2 bg-highlight/10 border-highlight/50 text-highlight shadow-lg shadow-highlight/20 transition-all duration-200 hover:scale-105"
    >
      <div className="text-2xl font-bold leading-none">{cpuCount}</div>
      <div className="text-[8px] uppercase font-semibold opacity-75 tracking-wider leading-none">
        CPU{cpuCount !== 1 ? "s" : ""}
      </div>
    </div>
  );
}

export default CpuCountLabel;
